import React from 'react'
import table from '../../../assets/brown-bg-brown-table-chair.webp'
import { Image, ListGroup, Col, Row, Button } from 'react-bootstrap'
import ItemCreateForm from './ItemCreateForm'
import CategoriesCreateForm from './CategoriesCreateForm'
import SubcategoriesCreateForm from './SubcategoriesCreateForm'
import CategoryBoxes from './categoryBoxes/CategoryBoxes'
import LowBoxes from './lowBoxes/LowBoxes'
import GenericTitleP from '../titles/GenericTitleP'

const Items = () => {

  const renderItems = () => {
    const allItems = []
    for(let i = 0; i < 100; i++){
      allItems.push(<ListGroup.Item key={i} className='d-flex justify-content-between' > <Image className='m-2' style={{maxHeight:"40px"}} src={table} /><p>Item-{i}</p> <p>Category-{i%7}</p> <p>Subcategory-{i%3}</p><div><Button variant='outline-warning'>Edit</Button><Button style={{marginLeft:"10px"}} variant='outline-danger'>Remove</Button> </div></ListGroup.Item>)
    }
    return allItems
  }

  return (
    <div className='p-2 pb-4'>
      <CategoryBoxes />
      <LowBoxes />
      <Row className='g-4'>
        <Col className='g-4' sm={12} md={6}>
          <GenericTitleP>Categories</GenericTitleP>
          <p>Should be used to filter as well</p>
          <div>
            {[0,1,2,3,4,5,6].map(x => <ListGroup.Item key={x} className='d-flex justify-content-between' >Category-{x} <div><Button variant='outline-warning'>Edit</Button><Button style={{marginLeft:"10px"}} variant='outline-danger'>Remove</Button> </div></ListGroup.Item>)}
          </div>
        </Col>
        <Col sm={12} md={6}>
          <GenericTitleP>SubCategories</GenericTitleP>
          <p>When the categories is chosen subcategories belonging to that category will be shown. Should be used to filter as well</p>
          <div>
          {[0,1,2].map(x => <ListGroup.Item key={x} className='d-flex justify-content-between' >Subcategory-{x} <div><Button variant='outline-warning'>Edit</Button><Button style={{marginLeft:"10px"}} variant='outline-danger'>Remove</Button> </div></ListGroup.Item>)}
          </div>
        </Col>
      <Col sm={12} className="mb-4">
        <GenericTitleP>All Items</GenericTitleP>
        <ListGroup style={{maxHeight:"400px", overflow:"scroll"}}>
          {renderItems()}
        </ListGroup>
      </Col>
      <Col className='' lg={6} sm={12} md={6}>
        <GenericTitleP>Create A New Item</GenericTitleP>
        <ItemCreateForm />
      </Col>
      <Col className='' >
        <div className='d-flex flex-column h-100 justify-content-between'>
          <div>

            <GenericTitleP>Create A New Category</GenericTitleP>
            <CategoriesCreateForm />
          </div>
          <div className='mt-4'>

            <GenericTitleP>Create A New Subcategory</GenericTitleP>
            <SubcategoriesCreateForm />
          </div>
        </div>
      </Col>
      </Row>
    </div>
  )
}

export default Items